<template>
  <v-form ref="formSelect">
    <v-select
        v-model="item"
        :items="filters"
        :label="itemAction.name"
        :item-text="itemText"
        item-value="id"
        clearable
        multiple
        outlined
        dense>
          <template v-slot:prepend-item>
            <v-sheet class="px-4 pt-2" v-show="itemAction.search">
              <v-text-field v-model="search" label="Buscar" outlined dense/>
            </v-sheet>
          <v-divider></v-divider>
          </template>
          <template v-slot:item="{ item, attrs, on }">
            <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
              <v-list-item-action>
                <v-checkbox :input-value="active"></v-checkbox>
              </v-list-item-action>
                <v-list-item-content v-if="item.padre_id === 0">
                  <span class="font-weight-bold subtitle-2">{{itemText(item)}}</span>
                </v-list-item-content>
                <v-list-item-content v-else class="pl-3" v-text="itemText(item)" />
            </v-list-item>
          </template>
    </v-select>
  </v-form>
</template>

<script>
import axios from 'axios'
export default {
  props: ['itemAction', 'onSuccess', 'showItems', 'setterModel'],
  data: () => ({
    item: [],
    items: [],
    filters: [],
    search: ''
  }),
  created () {
    if (this.itemAction.url) {
      this.getDinamicData(this.itemAction.url)
    }
  },
  mounted () {
    this.seterModel(this.setterModel)
  },
  methods: {
    getDinamicData (url) {
      if (url !== '') {
        const token = this.$cookies.get('token')
        axios.get(url, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
          this.items = []
          if (this.itemAction.sub) this.items = this.SubItems(response.data)
          else this.items.push(...response.data)

          this.filters = []
          this.filters.push(...this.items)
        }).catch(error => {
          if (error == null) {}
        })
      } else {
        if (this.itemAction.sub) {
          this.items = this.SubItems(this.itemAction.items)
        } else {
          this.items.push(...this.itemAction.items)
        }
      }
    },
    itemText (item) {
      if (item && this.itemAction.nameid === 'tipo_adquisicion_ids') {
        return item.nombre
      }
      return item.nombre
    },
    SubItems (its) {
      const items = []
      its.map(item => {
        if (item.padre_id === 0) {
          items.push(item)
          if (item[this.itemAction.sub] && item[this.itemAction.sub].length > 0) {
            const list = this.SubItemsSub(item[this.itemAction.sub])
            items.push(...list)
          }
        }
      })
      return items
    },
    SubItemsSub (its) {
      const items = []
      its.map(item => {
        items.push(item)
        if (item[this.itemAction.sub] && item[this.itemAction.sub].length > 0) {
          const list = this.SubItemsSub(item[this.itemAction.sub])
          items.push(...list)
        }
      })
      return items
    },
    seterModel (val) {
      if (val) {
        this.item = val
      }
    }
  },
  computed: {
  },
  watch: {
    item (val) {
      if (val) {
        this.onSuccess({ id: this.itemAction.nameid, data: val })
      } else {
        this.onSuccess(val)
      }
    },
    showItems (vals) {
      if (this.itemAction.sub) {
        this.items = this.SubItems(vals)
      } else {
        this.items.push(...vals)
      }
    },
    search (val) {
      if (val === '') {
        this.filters = []
        this.filters.push(...this.items)
        return
      }
      if (this.itemAction.nameid === 'partidas') {
        this.filters = this.items.filter(item => item.cuenta === parseInt(val) || item.nombre.toLowerCase().includes(val.toLowerCase()))
      }
      if (this.itemAction.nameid === 'provedor_ids') {
        this.filters = this.items.filter(item => item.rfc === parseInt(val) || item.nombre.toLowerCase().includes(val.toLowerCase()))
      }
      // Agregar los seleccionados
      if (this.item.length > 0) {
        const seleccionados = this.items.filter(item => this.item.some(i => i === item.id))
        this.filters.unshift(...seleccionados)
      }
    }
  }
}
</script>

<style>

</style>
